export class LoginSSORequest {
  public sessionId: string;
    constructor() { }
  }